import styled, { css } from 'styled-components'
import { Button, contentColorStyle } from './button'

type PrimaryButtonType = 'default' | 'negative'

const typeStyles = {
    default: css`
        background-color: ${(p) => p.theme.colors.primary.default};

        &:hover {
            background-color: ${(p) => p.theme.colors.primary.green700};
        }

        &:active {
            background-color: ${(p) => p.theme.colors.primary.green900};
        }
    `,
    negative: css`
        background-color: ${(p) => p.theme.colors.primaryRed};
        border: 1px solid ${(p) => p.theme.colors.primaryRed};

        &:hover {
            border: 1px solid ${(p) => p.theme.colors.primaryRed};
        }

        &:active {
            border: 1px solid ${(p) => p.theme.colors.primaryRed};
        }
    `,
}

export const PrimaryButton = styled(Button)<{ $type?: PrimaryButtonType }>`
    ${(props) => typeStyles[props.$type ?? 'default']}
    ${(p) => contentColorStyle(p.theme.colors.white)}

    &:disabled {
        background-color: ${(p) => p.theme.colors.tertiary.tertiary200};
    }
`
